<header class="topbar">
  <div class="topbar-left">
    <button type="button" class="icon-btn menu-btn" (click)="menuToggle.emit()" aria-label="Toggle menu">
      <span class="material-symbols-outlined">menu</span>
    </button>

    <a class="brand" routerLink="/dashboard" aria-label="Hospital Ease home">
      <span class="brand-mark"><span class="material-symbols-outlined">add_box</span></span>
      <span class="brand-text">
        <span class="brand-name">Hospital Ease</span>
        <span class="brand-sub">CLIS Enterprise</span>
      </span>
    </a>

    <span class="divider"></span>

    <div class="tenant-chip">
      <span class="material-symbols-outlined tenant-icon">domain</span>
      <span class="tenant-text">
        <span class="tenant-name">{{ organizationName }}</span>
        <span class="tenant-code">{{ organizationCode }}</span>
      </span>
    </div>

    @if (locations().length) {
      <label class="theme-selector location-selector">
        <span class="material-symbols-outlined">location_on</span>
        <select (change)="onLocationSelect($any($event.target).value)" aria-label="Select location">
          @for (l of locations(); track l.id) {
            <option [value]="l.id" [selected]="l.id === selectedLocation()?.id">{{ l.name }}</option>
          }
        </select>
      </label>
    }
  </div>

  <div class="topbar-search" title="Global search: coming soon">
    <span class="material-symbols-outlined">search</span>
    <input type="text" placeholder="Search patients, UHID, doctors… (coming soon)" disabled />
  </div>

  <div class="topbar-right">
    <onevedai-menu align="end" (ovSelect)="onQuickAction($event)" class="quick-menu">
      <button slot="trigger" type="button" class="quick-action">
        <span class="material-symbols-outlined">add</span>
        <span>Quick Action</span>
        <span class="material-symbols-outlined caret">arrow_drop_down</span>
      </button>
      @for (action of quickActions; track action.value) {
        <onevedai-menu-item [value]="action.value">{{ action.label }}</onevedai-menu-item>
      }
    </onevedai-menu>

    <label class="theme-selector">
      <span class="material-symbols-outlined">palette</span>
      <select [value]="activeTheme" (change)="onThemeSelect($any($event.target).value)" aria-label="Select theme">
        @for (t of themes; track t.id) {
          <option [value]="t.id" [selected]="t.id === activeTheme">{{ t.label }}</option>
        }
      </select>
    </label>

    <button type="button" class="icon-btn" disabled title="Notifications: coming soon" aria-label="Notifications (coming soon)">
      <span class="material-symbols-outlined">notifications</span>
    </button>

    <span class="divider"></span>

    <app-user-profile-menu
      [userName]="userName"
      [userRole]="userRole"
      [userAvatar]="userAvatar"
      (profileClick)="onProfileClick()"
      (settingsClick)="onSettingsClick()"
      (logout)="onLogout()"
    ></app-user-profile-menu>
  </div>
</header>
